module.exports = __webpack_public_path__ + "img/cnaas_mobile.9fbf19f0.jpg";